import { Box, Flex, Radio, RadioGroup, Stack, Text, VStack } from '@chakra-ui/react'
import { Select } from 'chakra-react-select'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'src/hooks/store'
import { selectCartDetails, selectUserType } from 'src/redux/cart/selectors'
import { setCartDetails, setUserType } from 'src/redux/cart/slice'
import { UserType } from 'src/redux/cart/types'
import { useGetPostalCodes } from 'src/services/api/queries/queries'

const CustomerTypePicker = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const selectedUserType = useSelector(selectUserType)

  const cartDetails = useSelector(selectCartDetails)
  const { data: postalCodes } = useGetPostalCodes()

  const handlePostalChange = (
    selectedOption: { label: string; value: string },
    userType: UserType
  ) => {
    const selectedPostal = postalCodes?.find((pc) => pc.postal_code === selectedOption?.value)

    const updatedCartDetails = {
      ...cartDetails,
      [userType]: {
        ...cartDetails[userType],
        postalAddress: selectedPostal,
      },
    }
    dispatch(setCartDetails(updatedCartDetails))
  }

  const renderPostalCodesAndRadio = (
    placeholder: string,
    userType: UserType,
    radioLabel: string
  ) => {
    const initialValue = cartDetails[userType]?.postalAddress?.postal_code

    return (
      <VStack spacing={2} marginRight={10} align={'flex-start'}>
        <Box width={'15rem'}>
          <Select
            variant='filled'
            placeholder={placeholder}
            value={{ value: initialValue, label: initialValue }}
            onChange={(e) => handlePostalChange(e, userType)}
            options={postalCodes?.map((pc) => ({ value: pc.postal_code, label: pc.postal_code }))}
            isClearable={!!initialValue}
            isSearchable
          />
        </Box>
        <Radio size='lg' colorScheme='teal' value={userType}>
          {radioLabel}
        </Radio>
      </VStack>
    )
  }

  return (
    <Box bg='gray.50' p={5} borderRadius='md' shadow='sm'>
      <Text fontSize='2xl' mb={4} fontWeight='bold'>
        {t('userTypePicker.startTransporting')}
      </Text>
      <RadioGroup onChange={(e) => dispatch(setUserType(e as UserType))} value={selectedUserType}>
        <Flex>
          {renderPostalCodesAndRadio(
            t('userTypePicker.collectionZipPlaceholder'),
            UserType.Sender,
            t('userTypePicker.sender')
          )}
          {renderPostalCodesAndRadio(
            t('userTypePicker.deliveryZipPlaceholder'),
            UserType.Receiver,
            t('userTypePicker.receiver')
          )}
        </Flex>
      </RadioGroup>
      <Box mt={4}>
        {selectedUserType === UserType.Receiver && (
          <Text color='red.500' fontSize='sm'>
            {t('userTypePicker.receiverInfo')}
          </Text>
        )}
      </Box>
    </Box>
  )
}

export default CustomerTypePicker
